import apiClient from './apiClient';

const URL = process.env.REACT_APP_API_URL + '/notas-autorizacion-nuevo';

export const getNotas = async () => {
  const response = await apiClient(URL, { method: 'GET' });
  const data = await response.json();
  if (response.status !== 200) {
    throw new Error(data.message || 'Error al obtener las notas de autorización');
  }
  return data;
};

export const confirmarNota = async (id, cursosModificados) => {
  const response = await apiClient(`${URL}/${id}/confirmar`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ cursosModificados }),
  });
  
  const data = await response.json();
  if (response.status !== 200) {
    throw new Error(data.message || 'Error al confirmar la nota de autorización');
  }
  return data;
};

export const rechazarNota = async (id, motivoRechazo) => {
  const response = await apiClient(`${URL}/${id}/rechazar`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ motivo_rechazo: motivoRechazo }),
  });
  
  const data = await response.json();
  if (response.status !== 200) {
    throw new Error(data.message || 'Error al rechazar la nota de autorización');
  }
  return data;
};

export const deleteNota = async (id) => {
  const response = await apiClient(`${URL}/${id}`, {
    method: 'DELETE',
  });

  const data = await response.json();
  if (response.status !== 200) {
    throw new Error(data.message || 'Error al eliminar la nota de autorización');
  }
  return data;
};

export const getNotaById = async (id) => {
  const response = await apiClient(`${URL}/${id}`, { method: 'GET' });
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'Error al obtener la nota de autorización');
  }
  return data;
};

export const editNotaAutorizacion = async (id, payload) => {
  const response = await apiClient(`${URL}/${id}/editar`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.message || `Error ${response.status}`);
  }

  return await response.blob();
};

